import request from '@/utils/request'

export const createRefund = (id: string, amount: number, comment: string) =>
  request({
    url: `/admin/budgets/${id}/refund`,
    method: 'post',
    data: { amount, comment }
  })
